import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blogs-detail',
  templateUrl: './blogs-detail.component.html',
  styleUrls: ['./blogs-detail.component.css']
})
export class BlogsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
